import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CoreaiService } from './coreai.service';
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private token: string | null = null;
  endpoint = environment.nodeEndpoint;

  constructor(private http: HttpClient, private coreAIService:CoreaiService) { }

  getUserDetail() {
    const userInfo = localStorage.getItem('user_detail');
    return userInfo;
  }

  getUserName() {
    const userInfo = localStorage.getItem('user_detail');
    let name = null;
    if (userInfo) {
      name = JSON.parse(userInfo)?.name;
    }
    return name;
  }

  async getUserInfo() {
    try {
      const response = await fetch(`${environment.msADAccessTokenURL}`);
      let userInfo = await response.json();

      let token = userInfo[0]?.id_token;
      localStorage.setItem('token', token);
      let refresh_token = userInfo[0]?.refresh_token;
      localStorage.setItem('refresh_token', refresh_token);

      let access_token = userInfo[0]?.access_token;
      localStorage.setItem('access_token', access_token);

      let user_email = userInfo[0]?.email;
      localStorage.setItem('user_email', user_email);

      let userDetail = userInfo[0]?.user_claims;
      const preferredUsernameObject = userDetail.find((item: any) => item.typ === "user_name");

      if (preferredUsernameObject) {
        const usernameWithoutDomain = preferredUsernameObject?.val;

        let newInfo: any = { "accessToken": { "claims": { "OHR": usernameWithoutDomain } } };
        localStorage.setItem('okta-token-storage', JSON.stringify(newInfo))
      }

      const preferredUser: any = userDetail.find((item: any) => item.typ === "name");
      if (preferredUser) localStorage.setItem('okta-username', preferredUser?.val);

      return userInfo;
    } catch (error) {
      console.error('Error:', error);
    }
  }


  getTokenByRefreshToken() {
    let refresh_token: any = localStorage.getItem('refresh_token');
    return this.http.get(`${this.endpoint}refresh?refresh_token=${refresh_token}`);
  }

  getTokenByRefreshTokenSession() {
    let refresh_token: any = localStorage.getItem('refresh_token');

    return this.http.get(`${this.endpoint}refresh?refresh_token=${refresh_token}`)
      .subscribe((res: any) => {
        if (res?.status == 'success') {
          let userInfo = res?.data;
          let token = userInfo?.id_token;
          localStorage.setItem('token', token);
          let refresh_token = userInfo?.refresh_token;
          localStorage.setItem('refresh_token', refresh_token);
        } else {
          console.log('error', res?.message)
        }
      })
  }



  async getUserCostCode(): Promise<number> {
    const userInfoString = localStorage.getItem('user_detail');
    
    if (userInfoString) {
      const userInfo = JSON.parse(userInfoString);
      return userInfo?.u_cost_code ?? 0;
    }
    
    try {
      const res = await this.coreAIService.getUserDetail().toPromise();
      const userDetail = res?.result?.[0] ?? {};
      const costCode = userDetail?.u_cost_code  ?? 0;
      
      // Update local storage with the new user details
      localStorage.setItem('user_detail', JSON.stringify(userDetail));
      
      return costCode;
    } catch (error) {
      console.error("Error fetching user details:", error);
      return 0;
    }
  }


  async getBandInfo(): Promise<string> {
    const userInfoString = localStorage.getItem('user_detail');
    //return '4.4D';
    if (userInfoString) {
      const userInfo = JSON.parse(userInfoString);
      return userInfo?.u_band ?? '0';
    }
    
    try {
      const res = await this.coreAIService.getUserDetail().toPromise();
      const userDetail = res?.result?.[0] ?? {};
      const costCode = userDetail?.u_band ?? '0';
      
      // Update local storage with the new user details
      localStorage.setItem('user_detail', JSON.stringify(userDetail));
      
      return costCode;
    } catch (error) {
      console.error("Error fetching user details:", error);
      return '0';
    }
  }

  getUserEmail() {
    const userInfo = localStorage.getItem('user_detail');
    let email = null;
    if (userInfo) {
      email = JSON.parse(userInfo)?.email;
    }
    return email;
  }

  setToken(token: string): void {
    this.token = token;
  }

  getToken(tokenType: 'id' | 'access' = 'id'): string | null {
    try {
      const tokenStorage = localStorage.getItem('okta-token-storage');
      
      if (!tokenStorage) {
        console.log('No token storage found in session');
        return null;
      }
  
      const tokens = JSON.parse(tokenStorage);
      
      if (tokenType === 'id' && tokens.idToken?.idToken) {
        return tokens.idToken.idToken;
      }
      
      if (tokenType === 'access' && tokens.accessToken?.accessToken) {
        return tokens.accessToken.accessToken;
      }
  
      console.log(`No ${tokenType} token found in storage`);
      return null;
    } catch (error) {
      console.error('Error retrieving token from session storage:', error);
      return null;
    }
  }

  clearToken(): void {
    this.token = null;
  }


  

  // get user OHR id
  getOHR() {
    let userOHR = ''
    let userData = localStorage.getItem('okta-token-storage');
    if (userData) {
      let ohr_id = JSON.parse(userData)?.accessToken?.claims?.OHR;
      if (ohr_id) {
        userOHR = ohr_id;
      }
    }
    return userOHR;
  }




}
